import { useEffect, useState } from "react"
import { AwardCard } from "../award-card"
import { Badge } from "../ui/badge"
import { Award, Trophy, Shield, BadgeIcon as Certificate } from "lucide-react"

export default function Awardswidget() {

  const [data, setData] = useState(null)

useEffect(() => {
  fetch("/wp-json/custom/v1/awards-widget")
    .then(res => res.json())
    .then(res => setData(res))
}, [])

  const getIcon = (icon) => {
    const value =
      typeof icon === "object" ? icon.value : icon?.toLowerCase()

    switch (value) {
      case "award":
        return <Award className="w-10 h-10 text-primary" />
      case "trophy":
        return <Trophy className="w-10 h-10 text-primary" />
      case "shield":
        return <Shield className="w-10 h-10 text-primary" />
      case "certificate":
        return <Certificate className="w-10 h-10 text-primary" />
      default:
        return null
    }
  }

  if (!data) return null

  return (
    <section className="py-12 bg-white">
      <div className="container px-4 mx-auto">

        <div className="flex flex-col items-center mb-10 text-center">
          <Badge className="mb-2">Recognition</Badge>

          <h2 className="mb-4 text-3xl font-bold md:text-4xl">
            {data.title}
          </h2>

          <p className="max-w-2xl text-muted-foreground">
            {data.description}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
          {data.items?.map((item, index) => (
            <AwardCard
              key={index}
              icon={getIcon(item.icon)}
              title={item.title}
              description={item.description}
              year={item.year}
            />
          ))}
        </div>

      </div>
    </section>
  )
}